class VaccineContext {
  static vaccineName: string;
}

export default VaccineContext;